// @core/api/endpoints/secret/delete_kv_secret.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/secret';

/**
 * Delete KV secret versions
 * Soft-deletes the latest version(s) of a KV secret. Soft-deleted versions can be recovered via UndeleteKvSecretVersions. Specify version numbers to delete specific versions.
 */
export async function DeleteKvSecret(
  engine_id: string,
  path: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/kv/data/:path`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':path', encodeURIComponent(path));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
